import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useIsExternalClient } from '../externalUsers/useIsExternalClient';

/**
 * Clientes externos só podem permanecer em /cliente-externo.
 */
export function ExternalClientRouteGuard() {
  const { isExternalClient, loading } = useIsExternalClient();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading || !isExternalClient) {
      return;
    }
    if (!location.pathname.startsWith('/cliente-externo')) {
      navigate('/cliente-externo', { replace: true });
    }
  }, [isExternalClient, loading, location.pathname, navigate]);

  return null;
}
